module.exports = __webpack_public_path__ + "img/PeopleAndScreens.8038e492.png";